export const ADD_TO_CART = (state, survey) => {
  state.cart.push(survey)
}

export const REMOVE_FROM_CART = (state, tn) => {
  state.cart = state.cart.filter(function (item){
    if (item.tn != tn){
      return item
    }
  })
}

export const SET_SURVEY_PREVIEW = (state, survey) => {
  state.previewSurvey = survey
}

export const SET_SURVEYS = (state, surveys) => {
  state.surveys = surveys
  state.filteredSurveys = surveys
}

export const SET_TEMPLATEHASHES = (state, templateHashes) => {
  state.templateHashes = templateHashes
}